/**
 * Constantes entreprise hardcodées (Phase 96c — 1 juillet 2026).
 *
 * Ces constantes remplacent les lookups `settings.company_name` / `settings.company_display_name`
 * dans les documents visibles. Décision utilisateur : mettre en dur pour éviter les
 * régressions liées aux Settings vides ou aux vieilles factures créées avant Phase 93.
 *
 * - COMPANY_HEADER : nom affiché en tête de tous les documents (BL, facture, courrier,
 *   étiquette, devis, OF...). Toujours court, sans nom personnel.
 * - COMPANY_LEGAL : nom légal complet, uniquement utilisé dans le bulletin de paiement
 *   Swiss QR-Bill (norme SPC : creditor.name doit correspondre au titulaire de l'IBAN).
 *
 * Si un jour la raison sociale change, éditer uniquement ce fichier.
 */
export const COMPANY_HEADER = "Maison Thaï Conthey";
export const COMPANY_LEGAL = "Maison Thaï Pongsak Phimrat";
